import React from 'react';
import { connectHits } from 'react-instantsearch-dom';

import { StandardCardSmall } from '@components/pageModules/cards/standardCardSmall';
import { useSiteContext } from '@lib/context';

const Hits = ({ hits }) => {
  const { state } = useSiteContext();
  return (
    <>
      {state?.filters?.searchQuery.length > 0 && (
        <span className='block relative z-10 px-gutter text-grey blockH8 pt-8'>
          {hits?.length} Results for "{state?.filters?.searchQuery}"
        </span>
      )}
      <div className='px-gutter grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 pt-10 gap-x-4 gap-y-4 relative z-10'>
        {hits.map((hit, i) => (
          <StandardCardSmall key={i} {...hit} className='w-full' />
        ))}
      </div>
    </>
  );
};

export const FilterHits = connectHits(Hits);
